import React from 'react';
import clsx from 'clsx';
import {ErrorCauseBoundary, ThemeClassNames, useThemeConfig} from '@docusaurus/theme-common';
import {splitNavbarItems, useNavbarMobileSidebar} from '@docusaurus/theme-common/internal';
import NavbarItem from '@theme/NavbarItem';
import NavbarColorModeToggle from '@theme/Navbar/ColorModeToggle';
import NavbarMobileSidebarToggle from '@theme/Navbar/MobileSidebar/Toggle';
import NavbarLogo from '@theme/Navbar/Logo';

import CommandSearch from '@site/src/components/CommandSearch';
import styles from './styles.module.css';

type NavbarItems = ReturnType<typeof useThemeConfig>['navbar']['items'];

function NavbarItemsList({items}: {items: NavbarItems}) {
  return (
    <>
      {items.map((item, index) => {
        const navbarItem = item as React.ComponentProps<typeof NavbarItem>;
        return (
          <ErrorCauseBoundary key={index} onError={(error) => new Error(`A MuPag Docs navbar item failed: ${JSON.stringify(item)}`, {cause: error})}>
            <NavbarItem {...navbarItem} />
          </ErrorCauseBoundary>
        );
      })}
    </>
  );
}

export default function NavbarContent(): React.ReactElement {
  const mobileSidebar = useNavbarMobileSidebar();
  const items = useThemeConfig().navbar.items;
  const visibleItems = items.filter((item) => item.type !== 'search');
  const [leftItems, rightItems] = splitNavbarItems(visibleItems);

  return (
    <div className={clsx('navbar__inner', styles.contentGrid)}>
      <div className={clsx(ThemeClassNames.layout.navbar.containerLeft, 'navbar__items', styles.left)}>
        {!mobileSidebar.disabled && <NavbarMobileSidebarToggle />}
        <NavbarLogo />
        <NavbarItemsList items={leftItems} />
      </div>
      <CommandSearch />
      <div className={clsx(ThemeClassNames.layout.navbar.containerRight, 'navbar__items navbar__items--right', styles.right)}>
        <NavbarItemsList items={rightItems} />
        <NavbarColorModeToggle className={styles.colorModeToggle} />
      </div>
    </div>
  );
}
